module.exports = __webpack_public_path__ + "banquet/components/images/banquet_logo_2x.7f1cca321e52fd690822a618b40f102d.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/banquet_logo_2x.png
// module id = 533
// module chunks = 1